import { message, notification } from "antd";
import "../../style/notifications.scss";

const TITLES = {
  success: "Success",
  error: "Something went wrong",
  warning: "Attention needed",
  info: "Information",
};

notification.config({
  placement: "topRight",
  duration: 4.5,
  maxCount: 3,
  stack: false,
  top: 20,
});

const openNotification = (type = "info", title, description) => {
  const normalizedType = ["success", "error", "warning", "info"].includes(type)
    ? type
    : "info";

  notification[normalizedType]({
    message: description ? title : TITLES[normalizedType],
    description: description || title,
    className: `app-notification app-notification--${normalizedType}`,
    role: normalizedType === "error" ? "alert" : "status",
  });
};

Object.keys(TITLES).forEach((type) => {
  openNotification[type] = (content, duration) => {
    notification[type]({
      message: TITLES[type],
      description: content,
      duration: typeof duration === "number" ? duration : undefined,
      className: `app-notification app-notification--${type}`,
      role: type === "error" ? "alert" : "status",
    });
  };
  // Keep legacy `message.success(...)` calls on the same visual system while
  // feature modules are migrated incrementally.
  message[type] = openNotification[type];
});

export default openNotification;
